import {useAuthenticatedUser} from "hooks/useAuth";
import type {FC, ReactNode} from "react";
import {Navigate, useLocation} from "react-router";
import type {AccessPredicate} from "router/types";
import {getDefaultLandingPath} from "router/utils";
import type {Role} from "utils/roles";
import {isRoleAtLeast} from "utils/roles";

type RoleGuardProps = {
  children: ReactNode;
  roles?: Role[];
  canAccess?: AccessPredicate;
};

const RoleGuard: FC<RoleGuardProps> = ({children, roles, canAccess}) => {
  const user = useAuthenticatedUser();
  const location = useLocation();

  if (!user) return null;

  const notAllowed =
    (roles && !roles.some(role => isRoleAtLeast(user.role, role))) ||
    (canAccess && !canAccess(user));

  if (notAllowed) {
    const landing = getDefaultLandingPath(user);

    if (landing && location.pathname !== `/${landing}`) {
      return <Navigate to={`/${landing}`} replace />;
    } else {
      return <Navigate to="/forbidden" replace />;
    }
  }
  return <>{children}</>;
};

export default RoleGuard;
